import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {NewStockViewComponent} from "../new-stock-view/new-stock-view.component";
import {StockService} from "../../services/stock.service";
import {Stock} from "../../../shared/view-model/stock";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs/Subscription";
import {environment} from "../../../../environments/environment";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ErrorHandlerService} from "../../../core/visbos-core/error-handling/error-handler.service";

@Component({
  selector: 'vb-edit-stock',
  templateUrl: './edit-stock.component.html',
  styleUrls: ['./edit-stock.component.css']
})
export class EditStockComponent implements OnInit /*, AfterViewInit, AfterViewChecked*/ {

  environment = environment;

  form: FormGroup;

  @ViewChild(NewStockViewComponent)
  stockCmp: NewStockViewComponent;

  stock: Stock;

  constructor(private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private route: ActivatedRoute,
              private stockService: StockService,
              private sessionActions: SessionActions,
              private err: ErrorHandlerService) {
  }

  ngOnInit() {
    this.stock = this.route.snapshot.data['stock'];
    this.init();
  }

  /*
  ngAfterViewInit(): void {
    this.stockCmp.setItemOrDefaultValues();
  }

  /*
  ngAfterViewChecked(): void {
    this.cd.detectChanges();
    //TODO: Very unperformant!!!
  }*/

  init() {
    this.form = this.fb.group({
      stock: NewStockViewComponent.initControl(this.fb)
    });
  }

  onSaveClicked() {
    let data = this.form.value.stock;
    this.stockService.updateStock(data, data.cuid).toPromise()
      .then(() => {
        this.sessionActions.pushMessage("Änderungen gespeichert", MessageType.SUCCESS, "Bestandsverwaltung");
      })
      .catch((err) => {
        this.err.handleUserError(err, "Fehler beim Speichern der Änderung!")
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/edit-stock/edit-stock.component.ts